import uid from "common/utils/uid";
import { docInitElevationViews, docInitPlanViews, docInitView3Ds } from "../../docInitViews";
import type { DocMigration } from "../docMigration";

const emptyViewFilter = Object.freeze({
  annotation: false,
  annotationAllByBackgroundSheet: undefined,
  annotationBrochurePlan: false,
  annotationCatalogOrigin: false,
  annotationCatalogs: false,
  annotationElectricalPlan: false,
  annotationFloorPlan: false,
  annotationFoundationPlan: false,
  annotationMechanicalPlan: false,
  annotationPlumbingPlan: false,
  annotationRoofPlan: false,
  annotationShowroomPlan: false,
  annotationStructuralPlan: false,
  annotationUtilityPlan: false,
  baseTrimMolding: false,
  camera: false,
  casework: false,
  ceilings: false,
  columns: false,
  cornerBoards: false,
  crossSection: false,
  crownTrimMolding: false,
  doors: false,
  doorSwings: false,
  doorTags: false,
  doorUnits: false,
  driveways: false,
  electrical: false,
  elevationAnnotation: false,
  elevationNotes: false,
  exteriorAutoDimensions: false,
  exteriorLightProbes: false,
  exteriorStaircases: false,
  faceDiff: false,
  floorAreas: false,
  floorFraming: false,
  flooring: false,
  floorKeyMeasures: false,
  floorMaterialAreas: false,
  foundation: false,
  foundationAutoDimensions: false,
  foundationKeyMeasures: false,
  gableEndWallFraming: false,
  grid: false,
  hoveredRoom: false,
  interiorAutoDimensions: false,
  interiorLightProbes: false,
  interiorLights: false,
  interiorStaircases: false,
  issues: false,
  lut: false,
  mask: false,
  overrides: false,
  patios: false,
  perimeter: false,
  porches: false,
  porchKeyMeasures: false,
  procureProps: false,
  props: false,
  railingPosts: false,
  railings: false,
  referenceGeom: false,
  roofing: false,
  roofKeyMeasures: false,
  roofs: false,
  rooms: false,
  roomsSalesLabels: false,
  sao: false,
  sceneLights: false,
  sheet: false,
  site: false,
  siteLightProbes: false,
  homeSideIndicator: false,
  solarPotential: false,
  stair: false,
  stairSystems: false,
  subFlooring: false,
  underlays: false,
  wainscoting: false,
  wallAssemblies: false,
  wallFraming: false,
  walls: false,
  warmup: false,
  windows: false,
  windowShutters: false,
  windowTags: false,
  windowUnits: false,
});

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_241: DocMigration = {
  maxSchemaVersion: "0.0.241",
  description: "Views - Add defaults for each level and migrate the existing viewer filter to a plan view",
  apply(json: any) {
    const migratedPlanViewId = uid();

    const hiddenValues: any[] = Object.values(json.hidden ?? {});

    json.planViews = {
      [migratedPlanViewId]: {
        entityType: "PLAN_VIEW",
        id: migratedPlanViewId,
        sortIndex: 0,
        name: "Migrated Plan View",
        referenceType: "EMPTY",
        viewFilter: { ...emptyViewFilter, ...json.viewerFilter },
        levelIds: Object.keys(json.levels).filter((levelId) => !hiddenValues.find((x) => x.levelId === levelId)),
      },
    };

    json.view3Ds = {};
    json.elevationViews = {};

    json.openViewIds = [migratedPlanViewId];
    json.activeViewId = migratedPlanViewId;

    json = docInitView3Ds(json);
    json = docInitElevationViews(json);
    return docInitPlanViews(json);
  },
};

export default migration_0_0_241;
